import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const credentials = [
  "2+ years coaching experience",
  "Former Master Trainer at LA Fitness",
  "Built around serious results",
];

export default function MeetCoach() {
  return (
    <section className="py-24 md:py-32 bg-[var(--dvx-surface)] transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
              Meet Your Coach
            </span>
            <h2 className="mt-4 font-oswald text-4xl md:text-5xl font-bold text-[var(--dvx-text)] uppercase tracking-tight">
              Coach Vishal Duhan
            </h2>
            <p className="mt-6 text-[var(--dvx-text-muted)] font-manrope text-lg leading-relaxed max-w-lg">
              Elite personal trainer and transformation specialist focused on
              physique development, strength progression, accountability, and
              premium client experience.
            </p>

            {/* Credential pills */}
            <div className="mt-8 flex flex-wrap gap-3">
              {credentials.map((c, i) => (
                <span
                  key={i}
                  className="border border-[var(--dvx-border)] text-[var(--dvx-text-muted)] font-manrope text-sm px-4 py-2 hover:border-[var(--dvx-primary)] hover:text-[var(--dvx-primary)] transition-colors duration-200"
                >
                  {c}
                </span>
              ))}
            </div>

            <div className="mt-10">
              <Link to="/contact">
                <button className="px-8 py-4 bg-gradient-to-r from-[var(--dvx-primary)] to-[var(--dvx-primary-dark)] text-white font-oswald font-bold uppercase tracking-widest hover:scale-105 transition-transform flex items-center gap-2">
                  Apply For Coaching <ArrowRight size={18} />
                </button>
              </Link>
            </div>
          </motion.div>

          {/* Right — placeholder image area with orange gradient like screenshot */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative aspect-[4/5] overflow-hidden border border-[var(--dvx-border)]">
              {/* Image */}
              <img
                src="/images/vishal.png"
                alt="Vishal Dhuhan"
                className="absolute inset-0 w-full h-full object-cover z-0"
              />

              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 to-transparent z-10" />

              {/* Text */}
              <div className="absolute bottom-6 left-6 z-30">
                <div className="font-oswald text-white text-2xl font-bold uppercase">
                  Vishal Duhan
                </div>
                <div className="text-white/70 font-manrope text-sm mt-1">
                  DVX Head Coach
                </div>
              </div>
            </div>

            {/* Decorative border accents */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-[var(--dvx-primary)]" />
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-[var(--dvx-primary)]/20" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
